
@switch (type) {
  @case ('brutto') {
    <ng-container i18n>inkl. MwSt.</ng-container>
  }
  @case ('netto') {
    <ng-container i18n>exkl. MwSt.</ng-container>
  }
  @case ('neutral') {
  }
}
